// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3ijmM","subheader":"ReorderModal_subheader__ZIx02","listWrap":"ReorderModal_listWrap__35DNL"};